export function openTeamsShareDialog(message: string, href: string): void {
  const teamsUrl = `https://teams.microsoft.com/share?msgText=${encodeURIComponent(message)}&href=${encodeURIComponent(href)}`
  window.open(teamsUrl, '_blank', 'width=700,height=600')
}

const MSG_TEXT_LIMIT = 200

export function buildMicroLearningShareMessage(
  mlId: string,
  title: string,
  summary: string,
): string {
  const messageHeader = `<br/><b>📊 Micro-learning ${mlId}: ${title}</b>`

  const message = summary
    ? `${messageHeader}<br/>${summary}`
    : messageHeader

  if (message.length <= MSG_TEXT_LIMIT) {
    return message
  }
  return message.slice(0, MSG_TEXT_LIMIT - 1) + '…'
}
